import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    campId: '40613-120-16-101.1',
    questions: {
      1: 'Wie wird der Dachs in Fabeln genannt?',
      2: 'Wofür können Microgreens genutzt werden?',
      3: 'Welchen Platz belegte Sandra Studer am ESC 1991?',
      4: 'Wie viele Feuerstellen der «Schweizer Familie» gibt es?',
      5: 'Was war früher ein No-go für Frauen in Tracht?',
    },
    answers: [
      {
        step: '1',
        options: [
          {
            value: 'Meister Grimbart',
            rightAnswer: true,
          },
          {
            value: 'Meister Petz',
            rightAnswer: false,
          },
        ],
      },
      {
        step: '2',
        options: [
          {
            value: 'Zum Konservieren',
            rightAnswer: false,
          },
          {
            value: 'Zum Würzen',
            rightAnswer: true,
          },
        ],
      },
      {
        step: '3',
        options: [
          {
            value: '5. Platz',
            rightAnswer: true,
          },
          {
            value: '15. Platz',
            rightAnswer: false,
          },
        ],
      },
      {
        step: '4',
        options: [
          {
            value: 'Mehr als 500',
            rightAnswer: true,
          },
          {
            value: 'Rund 250',
            rightAnswer: false,
          },
        ],
      },
      {
        step: '5',
        options: [
          {
            value: 'Schwarzer Regenschirm',
            rightAnswer: false,
          },
          {
            value: 'Rote Lippen',
            rightAnswer: true,
          },
        ],
      },
    ],
    userAnswers: [],
    dispense: false,
    resultText: [
      {
        count: '0',
        text: {
          headline: 'Leider nichts!',
          paragraph:
            'Damit Sie unser vielseitiges Land besser kennenlernen, schenken wir Ihnen als Sofortpreis 3 Ausgaben der «Schweizer Familie». Und natürlich haben Sie immer noch die Chance auf unseren Hauptpreis: drei Nächte in der exklusiven Romantik Suite des historischen Hotel Bären im Emmental.',
        },
      },
      {
        count: '1',
        text: {
          headline: 'Besser als nichts!',
          paragraph:
            'Es ist nie zu spät, unser vielseitiges Land besser kennenzulernen. Als Sofortpreis schenken wir Ihnen 3 Ausgaben der «Schweizer Familie». Und natürlich haben Sie immer noch die Chance auf unseren Hauptpreis: drei Nächte in der exklusiven Romantik Suite des historischen Hotel Bären im Emmental.',
        },
      },
      {
        count: '2',
        text: {
          headline: 'Fast die Hälfte gewusst!',
          paragraph:
            'Die Schweiz ist so vielseitig, dass man immer wieder Neues entdecken kann. Deshalb schenken wir Ihnen als Sofortpreis 3 Ausgaben der «Schweizer Familie». Und natürlich haben Sie immer noch die Chance auf unseren Hauptpreis: drei Nächte in der exklusiven Romantik Suite des historischen Hotel Bären im Emmental.',
        },
      },
      {
        count: '3',
        text: {
          headline: 'Nicht schlecht, aber da ist noch Luft nach oben.',
          paragraph:
            'Man kann nicht alles wissen, denn die Schweiz ist so vielseitig, dass man immer wieder Neues entdeckt. Deshalb schenken wir Ihnen als Sofortpreis 3 Ausgaben der «Schweizer Familie». Und natürlich haben Sie immer noch die Chance auf unseren Hauptpreis: drei Nächte in der exklusiven Romantik Suite des historischen Hotel Bären im Emmental.',
        },
      },
      {
        count: '4',
        text: {
          headline: 'Sie kennen sich aus!',
          paragraph:
            'Gratulation zu diesem Resultat. Doch die Schweiz ist so vielseitig, dass man immer noch etwas Neues entdecken kann. Deshalb schenken wir Ihnen als Sofortpreis 3 Ausgaben der «Schweizer Familie». Und natürlich haben Sie immer noch die Chance auf unseren Hauptpreis: drei Nächte in der exklusiven Romantik Suite des historischen Hotel Bären im Emmental.',
        },
      },
      {
        count: '5',
        text: {
          headline: 'Besser geht’s nicht!',
          paragraph:
            'Gratulation zu Ihrem Spitzen-Resultat. Doch die Schweiz ist so vielseitig, dass man trotzdem immer noch etwas Neues entdecken kann. Deshalb schenken wir Ihnen als Sofortpreis 3 Ausgaben der «Schweizer Familie». Und natürlich haben Sie immer noch die Chance auf unseren Hauptpreis: drei Nächte in der exklusiven Romantik Suite des historischen Hotel Bären im Emmental.',
        },
      },
    ],
    resultResolution: [
      {
        step: '1',
        text:
          'In Fabeln wird der Dachs als Meister Grimbart bezeichnet. Passend zu diesem Namen gilt er dort als mürrischer, aber sehr kluger Einzelgänger, der die Ruhe in seinem riesigen Erdbau schätzt. Weitere interessante Tierreportagen finden Sie in der «Schweizer Familie».',
      },
      {
        step: '2',
        text:
          'Microgreens werden in der Küche vor allem zum Würzen und Verfeinern von Gerichten genutzt. Trotz ihrer geringen Grösse stecken die jungen Keimlinge voller intensiver Aromen und gesunder Nährstoffe. Feine Rezepte mit abwechslungsreichen Zutaten finden Sie immer donnerstags in der «Schweizer Familie».',
      },
      {
        step: '3',
        text:
          'Sandra Studer belegte beim ESC 1991 den 5. Platz. Unter dem Künstlernamen Sandra Simó überzeugte sie damals mit dem italienischsprachigen Titel «Canzone per te». Spannende Interviews mit interessanten Persönlichkeiten finden Sie jeden Donnerstag in der «Schweizer Familie».',
      },
      {
        step: '4',
        text:
          'Es gibt tatsächlich über 570 Feuerstellen der «Schweizer Familie» in der ganzen Schweiz. Sie liegen oft idyllisch im Wald oder am Wasser und sind meist perfekt mit Holz und einem Grillrost ausgestattet. Alle Feuerstellen finden Sie unter schweizerfeuerstellen.ch. Die schönsten Ausflugstipps für Klein und Gross finden Sie Woche für Woche in der «Schweizer Familie».',
      },
      {
        step: '5',
        text:
          'Früher galten rote Lippen als absolutes No-go beim Tragen einer Tracht. Das traditionelle Gewand stand ganz im Zeichen von Schlichtheit und Natürlichkeit, weshalb jegliche künstliche Kosmetik verpönt war. Entdecken Sie jede Woche die Vielfalt der Schweizer Kultur in der «Schweizer Familie».',
      },
    ],
  },
  getters: {
    getQuestion: (state) => (step) => {
      return state.questions[step];
    },
    getAnswers: (state) => (quizStep) => {
      return state.answers.find((answer) => answer.step === String(quizStep));
    },
    getUserAnswers: (state) => {
      return state.userAnswers;
    },
    getResultText: (state) => (trueAnswersCount) => {
      return state.resultText.find(
        (text) => text.count === String(trueAnswersCount)
      );
    },
    getResultResolution: (state) => {
      return state.resultResolution;
    },
    getCampId: (state) => {
      return state.campId;
    },
    getDispense: (state) => {
      return state.dispense;
    },
  },
  mutations: {
    setAnswer(state, { answer }) {
      state.userAnswers.push(answer);
    },
    resetAnswers(state) {
      state.userAnswers = [];
    },
    setCampId(state, { campId }) {
      state.campId = campId;
    },
    setDispense(state, dispense) {
      state.dispense = dispense;
    },
  },
  actions: {
    setAnswer(context, answer) {
      context.commit('setAnswer', answer);
    },
    resetAnswers(context) {
      context.commit('resetAnswers');
    },
    setCampId(context, campId) {
      context.commit('setCampId', campId);
    },
    setDispense(context, dispense) {
      context.commit('setDispense', dispense);
    },
  },
  modules: {},
});
